/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : IMAGE PANE : LOADING : STYLES --------------- ++++++++++ */
export default theme => ({
	loading: {
		textAlign: 'center',
		'& p':{
			padding:pxToEm(25)
		},
		"& img": {
			width: pxToEm(100)
		}
	}
});
